module.exports = __webpack_public_path__ + "static/media/detailsTable.bcf2e9f7.svg";